// El nombre real del tenant se carga dinámicamente vía TenantContext.
// Aquí solo se usa como fallback estático para document.title antes de que cargue el contexto.
export const company = {
  name: import.meta.env.VITE_COMPANY_NAME || "CRM",
}